import { useQuery } from '@apollo/react-hooks';
import { GET_GRADING } from './GRADING.gql';
import type { DrcDrading, GetDrcScore } from './types';

export const useGetDrcScore = (applicationId: string): GetDrcScore => {
  const { data, loading, error, refetch } = useQuery(GET_GRADING, {
    variables: { applicationId },
    skip: !applicationId,
    fetchPolicy: 'network-only',
  });

  const drcDrading: DrcDrading = data?.queryDSRCGrading ?? {};

  return { drcDrading, loading, error, refetch };
};
